import React, { useState } from "react";
import PropTypes from "prop-types";
import TechGroupHeadDealTrackerModal from "./tech-group-head-deal-tracker-modal";
import GroupHeadDealTracker from "./group-head-deal-tracker";
import { GetTechGHDealTrackerExcelExport } from "../../../../services/api/dashboard-api";
import "../dashboard-group-head-tech.scss";

const TechGroupHeadDealTracker = ({ items }) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [show, setShow] = useState(false);

  const showModal = (project) => {
    setSelectedProject(project);
    setShow(true);
  };

  const onHide = () => {
    setSelectedProject(null);
    setShow(false);
  };

  return (
    <>
      <GroupHeadDealTracker
        items={items}
        title="Deal Tracker"
        departmentTitle="GIB/Technology"
        showModal={showModal}
        exportData={GetTechGHDealTrackerExcelExport}
        exportDisabled={false}
      />
      {show && selectedProject && (
        <TechGroupHeadDealTrackerModal
          item={selectedProject}
          show={show}
          onHide={onHide}
          title={selectedProject.ProjectName}
          subTitle="Deal Tracker"
        />
      )}
    </>
  );
};

TechGroupHeadDealTracker.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      Project: PropTypes.shape({
        Id: PropTypes.number.isRequired,
        Name: PropTypes.string.isRequired,
        Owner: PropTypes.shape({
          Id: PropTypes.number.isRequired,
          Name: PropTypes.string.isRequired,
        }).isRequired,
        Members: PropTypes.arrayOf(
          PropTypes.shape({
            Id: PropTypes.number.isRequired,
            Name: PropTypes.string.isRequired,
          })
        ).isRequired,
      }).isRequired,
      ProjectDynamicFields: PropTypes.arrayOf(
        PropTypes.shape({
          Label: PropTypes.string.isRequired,
          Data: PropTypes.string.isRequired,
        })
      ).isRequired,
      ProjectMembers: PropTypes.arrayOf(
        PropTypes.shape({
          UserId: PropTypes.string,
          AnalystAssociate: PropTypes.string,
          LastWeekHours: PropTypes.string,
          WeekendHours: PropTypes.string,
          TotalHours: PropTypes.string,
          CurrentWeekHours: PropTypes.string,
          LastUpdated: PropTypes.string,
        })
      ),
      AggregateLastWeekHours: PropTypes.string.isRequired,
      AggregateWeekendHours: PropTypes.string.isRequired,
      AggregateTotalHours: PropTypes.string.isRequired,
      AggregateCurrentWeekHours: PropTypes.string.isRequired,
      Description: PropTypes.string.isRequired,
      LastUpdated: PropTypes.string,
      QtyMembers: PropTypes.number.isRequired,
      Staffer: PropTypes.shape({
        Id: PropTypes.number.isRequired,
        Name: PropTypes.string.isRequired,
      }).isRequired,
    })
  ),
};

export default TechGroupHeadDealTracker;
